var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"small":"","color":_vm.booleanIconDef[_vm.value].color}},[_vm._v(_vm._s(_vm.booleanIconDef[_vm.value].icon))])}
var staticRenderFns = []

export { render, staticRenderFns }